import {FlexCol} from '@quarks';
import styled from 'styled-components';

export const StyledContainer = styled(FlexCol)`
  padding: 0px var(--padding-x) 8px;
  border-top: 1px solid ${({theme}) => theme.divider.grey};
`;
